import { LoadState } from "../../constants/enums";
import { IOpportunities, IOpportunityState } from "./opportunites.types";

export const defaultOpportunity: IOpportunities = {
  venue_uuid: "",
  venue_name: null,
  venue_address: null,
  capacity: null,
  seating_capacity: null,
  floating_capacity: null,
  status: "ACTIVE",
  company_outlet_uuid: "",
  company_outlet_name: "",
  hold_details: [],
};

export const defaultOpportunityState: IOpportunityState = {
  list: {
    data: [],
    totalRecords: 0,
    currentRecords: 0,
    meta: {
      use_count: 0,
      created_count: 0,
    },
    loading: LoadState.InProgress,
    error: null,
  },
  opportunity: {
    data: defaultOpportunity,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
